<div class="main background">
  <router-outlet></router-outlet>
</div>
<lib-consent-banner></lib-consent-banner>
